import { ShieldCheck, MapPin, FileCheck2, Handshake, Clock4, Lock } from "lucide-react";
import { useReveal } from "@/lib/useReveal";

const TRUST_HANDSHAKE = "https://images.unsplash.com/photo-1521791136064-7986c2920216";

const BADGES = [
  {
    icon: ShieldCheck,
    title: "No Upfront Fees",
    body: "Pure contingency. You owe us nothing unless funds land in your hands.",
  },
  {
    icon: FileCheck2,
    title: "Licensed & Bonded",
    body: "Fully compliant with state surplus and asset recovery statutes.",
  },
  {
    icon: MapPin,
    title: "Texas Roots",
    body: "Locally founded and operated — serving counties across multiple states.",
  },
  {
    icon: Handshake,
    title: "Transparent Process",
    body: "You see every filing, every fee, every signature. No surprises.",
  },
  {
    icon: Clock4,
    title: "Fast Turnaround",
    body: "Most claims resolved in 60–180 days, depending on the court's docket.",
  },
  {
    icon: Lock,
    title: "Confidential",
    body: "Your information is private and never shared or sold. Period.",
  },
];

export const WhyChoose = () => {
  const ref = useReveal();
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      ref={ref}
      className="bg-[#FDFBF7] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 reveal lg:sticky lg:top-28">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#D4AF37]" />
              <span className="text-[#1E3A5F] text-xs uppercase tracking-[0.3em]">
                Why Lone Star
              </span>
            </div>
            <h2 className="font-serif-display text-[#0A192F] text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.05]">
              Quiet work.
              <br />
              <em className="italic text-[#1E3A5F]">Loud results.</em>
            </h2>
            <p className="mt-8 text-[#1E3A5F] text-lg leading-relaxed">
              We approach every claim with the discretion and rigor of a
              law firm and the care of a neighbor. You will know what is
              happening at every step.
            </p>

            <div className="relative mt-12 hidden lg:block">
              <img
                src={TRUST_HANDSHAKE}
                alt="Handshake — partnership and trust"
                className="w-full h-[320px] object-cover rounded-sm"
              />
              <div className="absolute inset-0 bg-[#0A192F]/15 rounded-sm" />
            </div>
          </div>

          <div className="lg:col-span-7 reveal" style={{ transitionDelay: "120ms" }}>
            <div className="grid sm:grid-cols-2 gap-px bg-[#E2DCD0]">
              {BADGES.map((b, i) => (
                <div
                  key={b.title}
                  data-testid={`trust-badge-${i}`}
                  className="bg-[#FDFBF7] p-8 hover:bg-[#F3F0E6] transition-colors"
                >
                  <b.icon className="h-7 w-7 text-[#D4AF37] mb-5" strokeWidth={1.5} />
                  <h3 className="font-serif-display text-xl text-[#0A192F] mb-2">
                    {b.title}
                  </h3>
                  <p className="text-[#1E3A5F] text-sm leading-relaxed">
                    {b.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
